var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/CommonStory/CommonStory.jinja"] = require( "front/components/CommonStory/CommonStory.jinja" );
dependencies["front/components/CommonSidebar/CommonSidebar.jinja"] = require( "front/components/CommonSidebar/CommonSidebar.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/PerspectivePopup/PerspectivePopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/PerspectivePopup/PerspectivePopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/PerspectivePopup/PerspectivePopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/CommonStory/CommonStory.jinja", false, "assets/app/front/pages/PerspectivePopup/PerspectivePopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "CommonStory")) {
var t_10 = t_7.CommonStory;
} else {
cb(new Error("cannot import 'CommonStory'")); return;
}
context.setVariable("CommonStory", t_10);
output += "\n";
env.getTemplate("front/components/CommonSidebar/CommonSidebar.jinja", false, "assets/app/front/pages/PerspectivePopup/PerspectivePopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "CommonSidebar")) {
var t_14 = t_11.CommonSidebar;
} else {
cb(new Error("cannot import 'CommonSidebar'")); return;
}
context.setVariable("CommonSidebar", t_14);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"PerspectivePopup\">\n        <div class=\"PerspectivePopup-headerImage\" data-animation=\"1\" data-animation-type=\"bubble-down\" data-animation-state=\"initial\">\n            <div class=\"PerspectivePopup-headerImageWrapper\">\n                <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1366_url"), env.opts.autoescape);
output += "\"\n                  srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1920_url"), env.opts.autoescape);
output += " 1920w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1680_url"), env.opts.autoescape);
output += " 1680w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w1366_url"), env.opts.autoescape);
output += " 1366w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w920_url"), env.opts.autoescape);
output += " 920w,\n                          ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"cover")),"w680_url"), env.opts.autoescape);
output += " 680w\"\n                  sizes=\"(max-width: 759px) 1, ";
output += "\n                         (min-width: 760px) and (max-width: 979px) 681, ";
output += "\n                         calc(100% - 240px)\" ";
output += "\n                  alt=\"\">\n            </div>\n        </div>\n        <div class=\"PerspectivePopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 22, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:perspective"])), env.opts.autoescape);
output += "\">Perspective</a></div>\n        <div class=\"PerspectivePopup-caption\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title")), env.opts.autoescape);
output += "</div>\n        <h2 class=\"PerspectivePopup-credits\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"subtitleContentRendered")), env.opts.autoescape);
output += "</h2>\n\n        <div class=\"PerspectivePopup-sidebarMobile\">\n            ";
output += runtime.suppressValue((lineno = 27, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonSidebar"), "CommonSidebar", context, [runtime.makeKeywordArgs({"data": {"content": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"sidebar")}})])), env.opts.autoescape);
output += "\n        </div>\n\n        <div class=\"PerspectivePopup-content\">\n            ";
output += runtime.suppressValue((lineno = 31, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStory"), "CommonStory", context, [runtime.makeKeywordArgs({"data": {"content": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"content"),"contenthtml": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"contenthtml")}})])), env.opts.autoescape);
output += "\n\n            <div class=\"PerspectivePopup-sidebarDesktop\">\n                ";
output += runtime.suppressValue((lineno = 34, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonSidebar"), "CommonSidebar", context, [runtime.makeKeywordArgs({"data": {"content": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"sidebar")}})])), env.opts.autoescape);
output += "\n            </div>\n        </div>\n\n        <div class=\"PerspectivePopup-footer\">\n            ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"other"))) {
output += "<div class=\"PerspectivePopup-footer-item PerspectivePopup-footer-item--stories\">\n                <div class=\"PerspectivePopup-footer-itemLeftBlock\">\n                    <h3>More from Perspective:</h3>\n                    <div class=\"PerspectivePopup-footer-moreLink\" data-hash=\"\">All Stories</div>\n                </div>\n                <ul class=\"PerspectivePopup-footer-itemRightBlock\">\n                    ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"other");
if(t_19) {t_19 = runtime.fromIterator(t_19);
var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("item", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += "\n                        <li data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") % 2) * 50, env.opts.autoescape);
output += "\">\n                            <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_20),"url"), env.opts.autoescape);
output += "\" class=\"PerspectivePopup-footer-item-storie\">\n                                <div class=\"PerspectivePopup-footer-item-storieImg\">\n                                    ";
if(runtime.memberLookup((t_20),"previewCover")) {
output += "<img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_20),"previewCover")),"w440_url"), env.opts.autoescape);
output += "\"\n                                      srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_20),"previewCover")),"w680_url"), env.opts.autoescape);
output += " 2x\"\n                                      alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_20),"title"), env.opts.autoescape);
output += "\">\n                                    ";
;
}
else {
if(runtime.memberLookup((t_20),"cover")) {
output += "\n                                    <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_20),"cover")),"w440_url"), env.opts.autoescape);
output += "\"\n                                      srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_20),"cover")),"w680_url"), env.opts.autoescape);
output += " 2x\"\n                                      alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_20),"title"), env.opts.autoescape);
output += "\">\n                                    ";
;
}
;
}
output += "\n                                </div>\n                                <div class=\"PerspectivePopup-footer-item-storieTitle\">\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((t_20),"title"), env.opts.autoescape);
output += "\n                                </div>\n                            </a>\n                        </li>\n                    ";
;
}
}
frame = frame.pop();
output += "\n                </ul>\n               <div class=\"PerspectivePopup-footer-moreLink PerspectivePopup-footer-moreLink--mobile\" data-hash=\"\">All Stories</div>\n            </div>\n            ";
;
}
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"issues"))) {
output += "<div class=\"PerspectivePopup-footer-item PerspectivePopup-footer-item--issues\">\n                <div class=\"PerspectivePopup-footer-itemLeftBlock\">\n                    <h3>Latest Perspective Issues:</h3>\n                    <div class=\"PerspectivePopup-footer-moreLink\" data-hash=\"archives\">All Issues</div>\n                </div>\n                <ul class=\"PerspectivePopup-footer-itemRightBlock\">\n                    ";
frame = frame.push();
var t_23 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"issues");
if(t_23) {t_23 = runtime.fromIterator(t_23);
var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("item", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += "\n                        <li data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") % 2) * 50, env.opts.autoescape);
output += "\">\n                            <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_24),"link"), env.opts.autoescape);
output += "\" class=\"PerspectivePopup-footer-item-issue\">\n                                <div class=\"PerspectivePopup-footer-item-issueImg\">\n                                    <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_24),"cover")),"w440_url"), env.opts.autoescape);
output += "\"\n                                      srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_24),"cover")),"w680_url"), env.opts.autoescape);
output += " 2x\"\n                                      alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_24),"title"), env.opts.autoescape);
output += "\">\n                                </div>\n                                <div class=\"PerspectivePopup-footer-item-issueTitle\">\n                                    ";
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"date"),"%B"), env.opts.autoescape);
output += "\n                                    ";
if(!runtime.memberLookup((t_24),"dateEnd") || env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"date"),"%B %Y") == env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"dateEnd"),"%B %Y") || env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"date"),"%Y") != env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"dateEnd"),"%Y")) {
output += "\n                                        ";
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"date"),"%Y"), env.opts.autoescape);
output += "\n                                    ";
;
}
output += "\n                                    ";
if(runtime.memberLookup((t_24),"dateEnd") && env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"date"),"%B %Y") != env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"dateEnd"),"%B %Y")) {
output += "\n                                        - <nobr>";
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_24),"dateEnd"),"%B %Y"), env.opts.autoescape);
output += "</nobr>\n                                    ";
;
}
output += "\n                                </div>\n                            </a>\n                        </li>\n                    ";
;
}
}
frame = frame.pop();
output += "\n                </ul>\n                <div class=\"PerspectivePopup-footer-moreLink PerspectivePopup-footer-moreLink--mobile\" data-hash=\"archives\">All Issues</div>\n            </div>\n            ";
;
}
output += "</div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/PerspectivePopup/PerspectivePopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/PerspectivePopup/PerspectivePopup.jinja
// module id = 544
// module chunks = 0